export default "/images/171caf9d6c1d9c56a4d31c9db16ebbfe.avif";